import React from 'react';
import { Clock, UserCircle, User, DollarSign, Send } from 'lucide-react';

export default function TimelineComunicaciones({ 
  solicitud, 
  getActionMeta, 
  getEstadoNombre, 
  setModalPrefill, 
  setModalCorreo 
}) {
  return (
    <div>
      <h3 style={{ marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: 8 }}>
        <Clock size={20} style={{ color: 'var(--copper)' }} /> Historial de Comunicaciones
      </h3>

      <div style={{ position: 'relative', paddingLeft: '1.5rem', borderLeft: '2px solid rgba(var(--copper-rgb), 0.2)' }}>
        {solicitud.workflow_steps?.length > 0 ? (
          solicitud.workflow_steps.map((step) => {
            let meta = getActionMeta(step.action);
            const esCiudadano = step.action === 'respuesta_ciudadano';
            const esPago = step.payload?.tipo === 'comprobante_pago';

            if (esPago) {
              meta = { ...meta, label: 'Comprobante de Pago Subido', color: '#059669', bg: '#f0fdf4', icon: <DollarSign size={14} /> };
            }
            return (
              <div key={step.id} style={{ marginBottom: '1.5rem', position: 'relative' }}>
                {/* Dot */}
                <span style={{
                  position: 'absolute', left: '-29px', top: '4px',
                  background: 'var(--bg-body)', padding: '3px', borderRadius: '50%',
                }}>
                  <div style={{
                    width: 10, height: 10,
                    background: meta.color,
                    borderRadius: '50%',
                  }} />
                </span>

                {/* Timestamp + author */}
                <p style={{ margin: '0 0 4px 0', fontSize: '0.78rem', color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: 8 }}>
                  {new Date(step.created_at).toLocaleString('es-CL', { dateStyle: 'short', timeStyle: 'short' })}
                  {esCiudadano ? (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><User size={13} /> Ciudadano</span>
                  ) : (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                      <UserCircle size={13} /> {(() => {
                        if (step.display_worker_name) return step.display_worker_name;
                        if (step.payload?.usuario || step.payload?.funcionario) {
                          const u = String(step.payload.usuario || step.payload.funcionario).trim();
                          if (u.toLowerCase().includes('admin')) return 'Sistema';
                          return u;
                        }
                        if (!step.worker) return 'Sistema';
                        const name = (step.worker.name || '').trim();
                        const role = (step.worker.role || '').toLowerCase();
                        if (!name || name.toLowerCase().includes('admin') || role === 'admin' || role === 'super_admin' || step.worker.id === 1) {
                          return 'Sistema';
                        }
                        return name;
                      })()}
                    </span>
                  )}
                </p>

                {/* Card */}
                <div style={{
                  background: meta.bg,
                  padding: '1rem',
                  borderRadius: '8px',
                  border: `1px solid ${meta.color}22`,
                }}>
                  <strong style={{
                    display: 'flex', alignItems: 'center', gap: 6,
                    marginBottom: '0.5rem', color: meta.color, fontSize: '0.88rem',
                  }}>
                    {meta.icon} {meta.label}
                  </strong>

                  {/* Asunto (correos) */}
                  {step.payload?.asunto && (
                    <p style={{ margin: '0 0 6px', fontSize: '0.85rem', fontWeight: 600, color: '#374151' }}>
                      {step.payload.asunto}
                    </p>
                  )}

                  {/* Mensaje o comentario */}
                  {(step.payload?.mensaje || step.payload?.comentario) && (
                    <p style={{ margin: 0, fontSize: '0.85rem', color: '#374151', whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
                      {step.payload.mensaje || step.payload.comentario}
                    </p>
                  )}

                  {/* Archivos adjuntados */}
                  {step.payload?.archivos?.length > 0 && (
                    <ul style={{ margin: '6px 0 0', paddingLeft: '1.2rem', fontSize: '0.82rem', color: '#374151' }}>
                      {step.payload.archivos.map((a, i) => <li key={i}>{a}</li>)}
                    </ul>
                  )}

                  {/* Cambio de estado */}
                  {step.action === 'cambio_estado' && step.payload?.changes?.estado_id && (
                    <div style={{ fontSize: '0.82rem', color: '#374151' }}>
                      Estado anterior <strong>{getEstadoNombre(step.payload.changes.estado_id.old)}</strong>
                      {' '}→ Estado nuevo <strong>{getEstadoNombre(step.payload.changes.estado_id.new)}</strong>
                    </div>
                  )}

                  {/* Nota genérica */}
                  {step.payload?.nota && !(step.payload?.mensaje || step.payload?.comentario) && (
                    <p style={{ margin: 0, fontSize: '0.82rem', fontStyle: 'italic', color: 'var(--text-muted)' }}>
                      {step.payload.nota}
                    </p>
                  )}

                  {/* Botón de Respuesta (si es mensaje de ciudadano) */}
                  {esCiudadano && (
                    <div style={{ marginTop: '0.8rem', display: 'flex', justifyContent: 'flex-end' }}>
                      <button 
                        className="btn btn-secondary btn-sm"
                        style={{ fontSize: '0.75rem', padding: '2px 10px', display: 'flex', alignItems: 'center', gap: 4 }}
                        onClick={() => {
                          setModalPrefill({ 
                            asunto: `RE: ${esPago ? 'Comprobante de Pago' : 'Consulta de Solicitud'}`,
                            mensaje: `\n\n--- Mensaje original ---\n${step.payload.comentario || ''}`
                          });
                          setModalCorreo(true);
                        }}
                      >
                        <Send size={12} /> Responder al Ciudadano
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <p className="text-muted">Sin historial registrado aún.</p>
        )}
      </div>
    </div>
  );
}
